import { DatabaseThinkingBar } from '@databases/ai-interactions-shared-ui/DatabaseThinkingBar';
import { abortDatabaseStream } from '@databases/rovo-bridge';
import React, { useCallback, useEffect, useRef } from 'react';

import { useDatabaseStreamState } from '../useDatabaseStreamState.ts';

interface DatabaseBoeThinkingBarProps {
  contentId: string;
  onDismiss: () => void;
  onStreamComplete?: () => void;
  placement?: 'fixed' | 'inline';
}

export const DatabaseBoeThinkingBar = ({
  contentId,
  onDismiss,
  onStreamComplete,
  placement = 'fixed'
}: DatabaseBoeThinkingBarProps) => {
  const { isStreaming } = useDatabaseStreamState();

  /**
   * Prevents the initial idle stream state from dismissing the bar.
   */
  const hasSeenStreamingRef = useRef(false);

  useEffect(() => {
    if (isStreaming) {
      hasSeenStreamingRef.current = true;
    } else if (hasSeenStreamingRef.current) {
      onStreamComplete?.() ?? onDismiss();
    }
  }, [isStreaming, onDismiss, onStreamComplete]);

  const status = isStreaming ? 'editing' : 'analyzing';

  const handleStop = useCallback(() => {
    abortDatabaseStream(contentId);
    onDismiss();
  }, [contentId, onDismiss]);

  return (
    <DatabaseThinkingBar status={status} onStop={handleStop} placement={placement} />
  );
};
